export function authApi(c) {
    return {
        register: (body) => c.post('/auth/register', body, { anonymous: true }),
        login: (body) => c.post('/auth/login', body, { anonymous: true }),
        me: () => c.get('/auth/me'),
    };
}
//# sourceMappingURL=auth.js.map